import * as React from 'react';
import styles from './style/SaveStatus.module.scss';
import saveStatusTexts from './texts';
import allSaved from '../../../../images/allSaved.png';
import loaderLastChanges from '../../../../images/loaderLastChanges.png';

enum saveStatus {
    NONE = 0,
    ALL_SAVED = 1,
    SAVING_CHANGES = 2
}

type Prop = {status: number};

const SavingStatus = ({status}: Prop) => {
    if (status === saveStatus.ALL_SAVED) {
        return (
            <div className={styles.saveStatus}>
                <img src={allSaved} alt="" />
                <div>{saveStatusTexts.allSaved}</div>
            </div>
        );
    } else if (status === saveStatus.SAVING_CHANGES) {
        return (
            <div className={styles.saveStatus}>
                <img alt="" className={styles.imageRotate} src={loaderLastChanges} />
                <div>{saveStatusTexts.savingChanges}</div>
            </div>
        );
    }

    return null;
};

export default SavingStatus;
